var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v("Step 7 of 9: Home Environment"),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-3" }, [
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [_vm._v("Pets")]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "home_env_pets",
                      placeholder: "Enter Pets",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("home_env_pets", val),
                    },
                    model: {
                      value: _vm.localFormData.home_env_pets,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "home_env_pets", $$v)
                      },
                      expression: "localFormData.home_env_pets",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Accessibility Issues "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "home_env_accessibility_issues",
                      placeholder: "Enter Accessibility Issues",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("home_env_accessibility_issues", val),
                    },
                    model: {
                      value: _vm.localFormData.home_env_accessibility_issues,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "home_env_accessibility_issues",
                          $$v
                        )
                      },
                      expression: "localFormData.home_env_accessibility_issues",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("Safety Concerns "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormInputGroup", {
                    attrs: {
                      name: "home_env_safety",
                      placeholder: "Enter Safety Concerns",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("home_env_safety", val),
                    },
                    model: {
                      value: _vm.localFormData.home_env_safety,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "home_env_safety", $$v)
                      },
                      expression: "localFormData.home_env_safety",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  attrs: { title: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v("General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      rows: 3,
                      customBorderClass: "borderTen",
                      name: "home_env_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                    },
                    on: {
                      input: (val) => _vm.updateField("home_env_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.home_env_notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "home_env_notes", $$v)
                      },
                      expression: "localFormData.home_env_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }